import React from 'react';

import { Flex, Text } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

import { ContentRoutes } from 'enums/routes';

export default function ChecklistExecutionHeader() {
  const { push } = useHistory();

  return (
    <Flex
      justifyContent="space-between"
      width="100%">
      <Text variant="xLargeBold">Check-lists respondidos</Text>
      <Text
        variant="smallSemiBold"
        cursor="pointer"
        onClick={() => push(`/table/${ContentRoutes.Checklists}`)}>Ver todos os Checklists
      </Text>
    </Flex>
  );
}
